module.exports = __webpack_public_path__ + "img/profile_pic_empty.263802f8.png";